import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import './AdminLogin.css';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!username.trim() || !password.trim()) {
      toast.error('Bitte Benutzername und Passwort eingeben');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/login`, {
        username: username.trim(),
        password: password.trim()
      });

      const { user, session_token } = response.data;

      // Check if user is admin
      if (!user.is_admin) {
        toast.error('Zugriff verweigert: Keine Admin-Berechtigung');
        setLoading(false);
        return;
      }

      // Store session info
      localStorage.setItem('admin_session_token', session_token);
      localStorage.setItem('admin_user', JSON.stringify(user));
      
      toast.success(`Willkommen zurück, ${user.name || user.username}!`);
      
      // Force full page reload to admin panel (React Router navigate doesn't work here)
      setTimeout(() => {
        window.location.href = '/admin';
      }, 500);
      
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.status === 401) {
        toast.error('Ungültiger Benutzername oder Passwort');
      } else {
        toast.error('Login fehlgeschlagen. Bitte versuchen Sie es erneut.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h1>🔐 Admin Login</h1>
          <p>Melden Sie sich an, um auf das Admin-Panel zuzugreifen</p>
        </div>
        
        <form onSubmit={handleLogin} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="username">Benutzername</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              autoComplete="username"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Passwort</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="admin-login-btn"
            disabled={loading}
          >
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>

        <div className="admin-login-footer">
          <button 
            className="back-to-home-btn"
            onClick={() => navigate('/')}
          >
            ← Zurück zur Startseite
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
